// eslint-disable-next-line jira/wrm/no-load-bridge
import {
	loadBridgeStrict,
	waitForHeritage,
	loadBridgeWeak,
} from '@atlassian/jira-common-bridge/src';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { LegacyApi } from '../../types.tsx';

const registerBridge = (legacyAPI: LegacyApi) => {
	if (fg('firefox_issue_view_memory_leak_v1')) {
		// eslint-disable-next-line jira/wrm/no-load-bridge
		return waitForHeritage()?.then(() =>
			// eslint-disable-next-line jira/wrm/no-load-bridge
			loadBridgeStrict({
				name: 'jira/globalnavigator/breadcrumbs/bridge',
				wrmKeys: ['wrc!com.atlassian.jira.jira-atlaskit-plugin:breadcrumbs'],
			})
				.then((bridge) => {
					// @ts-expect-error - TS2571 - Object is of type 'unknown'.
					bridge(legacyAPI);
				})
				.catch((err) => log.safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString())),
		);
	}
	// eslint-disable-next-line jira/wrm/no-load-bridge
	return loadBridgeWeak({
		name: 'jira/globalnavigator/breadcrumbs/bridge',
	})
		.then((bridge) => {
			// @ts-expect-error - TS2571 - Object is of type 'unknown'.
			bridge(legacyAPI);
		})
		.catch((err) => log.safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));
};

export default registerBridge;
